import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";

import { useAuthModalContext } from "app/contexts/authModal/context";
import { REDIRECT_URL_KEY } from "constants/app.constant";

// ---------------------------------------------------------------------------
// Route target for /login.
//
// The old standalone login page (src/app/pages/Auth/index.jsx) is still in
// the repo, untouched — it's just not wired to any route anymore. Landing
// on /login (typed directly, an old link, ?redirect=... after an expired
// session, etc.) no longer renders that page. Instead it opens the SAME
// global auth modal used everywhere else (Learning PSIR CTA, AI Samiksha
// gate, route error boundary — see components/shared/AuthModal.jsx) and
// immediately leaves the /login URL, so the modal just floats on top of
// wherever the person actually lands.
// ---------------------------------------------------------------------------

export default function LoginModalRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { openAuthModal } = useAuthModalContext();
  const opened = useRef(false);

  useEffect(() => {
    if (opened.current) return;
    opened.current = true;

    const redirect = searchParams.get(REDIRECT_URL_KEY);

    openAuthModal({
      label: "Raajneeti AI",
      onSuccess: () => navigate(redirect || "/raajneeti/home", { replace: true }),
    });

    navigate(redirect || "/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}